<template>
    <div class="h-screen-dis">
        <div ref="formContainer" :class="mainClass">
            <div v-if="showMainPad">
                <div v-if="siteInfo.ErrorMsg.length > 0" id="ci_error_msg" class="hwifMk">
                    <div class="msg">{{ siteInfo.ErrorMsg }}</div>
                    <div class="btn" @click="deleteError">X</div>
                </div>
                <main id="view-form-main" style="position: relative;">
                    <Vueform ref="form" :disabled="true" :schema="formData" />
                    <div class="ci-cover"></div>
                </main>
                <Files :files="formFiles" :img="false" :signature="false"></Files>
                <Files :files="formImages" :img="true" :signature="false"></Files>
                <Files :files="formSignature" :img="true" :signature="true"></Files>
                <KeyValue v-if="showSubmissionDate" title="Submission Date" :value="submissionDate"></KeyValue>
            </div>
            <div style="text-align: center; padding: 50px;" v-if="showPermissionsCheckPad">
                <h3>Checking Permissions...</h3>
            </div>
            <div style="text-align: center; padding: 50px;" v-if="showLoginPad">
                <h3>This form submission requires <button style="text-decoration: underline;" @click="handleLogin">login</button>.</h3> 
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Images from "../components/Images.vue";
import Files from "../components/Files.vue";
import KeyValue from "../components/KeyValue.vue";
import { emptyData } from '../data';
import { apiConfig } from '../config/api';
import { useAuth } from "../auth/useMsAuth";
import { getFormStatus, getFilesData, checkFilesSchema } from '../utilities/dataHelper';
const { userState, msalApp, postRequest, retryLogin } = useAuth();


export default {
    name: 'View',
    data() {
        return {
            mainClass: 'ci-form-main-iframe',
            formData: emptyData.schema,
            submissionData: {},
            userState: userState,
            times: 0,
            siteInfo: {
                ErrorMsg: '',
                EnableSave: false
            },
            formInfo: {
                Title: 'My Form',
                //Id: parseInt(this.$route.params['formId'] || 0),
                Uid: this.$route.params['submissionUid'],
                Id: 0,
                SiteId: 5,
                FolderId: 0,
                Data: '',
                HasPub: false,
                HasDraft: false
            },
            state: {
                resizeObserve: null
            },
            formFiles: [],
            formImages: [],
            formSignature: [],
            fileSchema: null,
            imageSchema: null,
            signatureSchema: null,
            submissionDate: '',
            showSubmissionDate: false,
            showMainPad: false,
            showPermissionsCheckPad: true,
            showLoginPad: false
        }
    },
    components: {
        Images,
        Files,
        KeyValue,
    },
    methods: {
        updateData(){
            this.times += 1;
            if(this.times <= 2) {
                this.$refs.form.update(this.submissionData);
                setTimeout(() => {
                    this.updateData();
                }, 100);

            }
        },
        handleLogin() {
            try {
                msalApp
                .loginPopup(postRequest)
                .then((res) => {
                    this.userState.isAuthenticated = true;
                    this.userState.token = res.accessToken;
                    this.userState.user = res.account;

                    this.reviewSubmission();
                })
                .catch((e) => {
                    console.error("loginPopup error", e);
                });
            } catch (e) {
                console.error("loginPopup error:", e);
            }
        },
        checkPermissions(permissions) {
            if(this.userState.isAuthenticated || !permissions) {
                return true;
            }
            return false;
        },
        deleteError() {
            this.siteInfo.ErrorMsg = '';
        },
        reviewSubmission(){
            axios({
                method: 'post',
                url: `${apiConfig.GetSubmissionViewUrl}/${this.formInfo.Uid}`,
            }).then((res) => {

                const flag = this.checkPermissions(res.data?.form?.permissions);

                if(flag) {
                    this.showPermissionsCheckPad = false;
                    this.showLoginPad = false;
                    this.showMainPad = true;
                    let formInfo = res.data.form;
                    let submInfo = res.data.subm;
                    this.loadFormSchema(formInfo, submInfo);
                } else {

                    this.showPermissionsCheckPad = false;
                    this.showLoginPad = true;
                    this.showMainPad = false;

                }



            }).catch(e => {
                console.error('[review submission] error:', e);
                this.siteInfo.ErrorMsg = `getting form submission error: ${e.message}`;
                this.formData = emptyData.schema;
            });
        },
        loadFormSchema(result, submInfo) {

            const status = getFormStatus(result);
            const title = result.title;
            let _fromData = (result.data || "");
            if (_fromData.length < 100) {
                _fromData = JSON.stringify(emptyData);
            }
            this.formInfo = {
                Id: parseInt(result.id),
                SiteId: parseInt(result.siteId || 5),
                FolderId: parseInt(result.folderId),
                Title: title,
                Uid: this.$route.params["submissionUid"],
                Data: _fromData,
                Status: status
            };


            let schema = JSON.parse(_fromData).schema;

            let fileSchema = {};
            let imageSchema = {};
            let signatureSchema = {};

            checkFilesSchema(fileSchema, imageSchema, signatureSchema, schema);
            this.fileSchema = fileSchema;
            this.imageSchema = imageSchema;
            this.signatureSchema = signatureSchema;

            this.formData = schema;

            this.loadFormSubmission(submInfo);
        },
        loadFormSubmission(submInfo){
            let data = JSON.parse(submInfo.data);

            let date = new Date(submInfo.utc);
            data.SubmissionDate = date.toLocaleString();

            this.submissionData = data;

            //this.$refs.form.update(data);

            this.showFormFiles(data);

            this.submissionDate = data?.SubmissionDate || '';
            this.showSubmissionDate = true;

            // fix phone number review
            setTimeout(() => {
                this.updateData();
            }, 100);
        },
        showFormFiles(data){
            this.formFiles = getFilesData(this.fileSchema, data);
            this.formImages = getFilesData(this.imageSchema, data);
            this.formSignature = getFilesData(this.signatureSchema, data);
        },
        loadEmptyData() {
        },
    },
    created() {

    },
    async mounted() {

        this.$nextTick(() => {

            if (!this.state.resizeObserve) {
                this.state.resizeObserve = new ResizeObserver((entires) => {
                    for (const entry of entires) {
                        if (entry.target === this.$refs.formContainer) {
                            let formHeight = this.$refs.formContainer?.offsetHeight;
                            if (formHeight) {
                                let formId = this.formInfo.Id;
                                let cbMsg = {
                                    type: 'Form.Resize',
                                    id: formId,
                                    val: formHeight + 10
                                };
                                console.info('[postMessage]', cbMsg);
                                parent.postMessage(cbMsg, "*")

                            }
                        }
                    }
                });
            }
            this.state.resizeObserve.observe(this.$refs.formContainer);
        });
        this.reviewSubmission();
    },
}
</script>